
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiTwowayStackedClosedRight as ObiTwowayStackedClosedRightElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-twoway-stacked-closed-right.js';
 
 
 

 
 export const ObiTwowayStackedClosedRight = createComponent({
   react: React,
   tagName: 'obi-twoway-stacked-closed-right',
   elementClass: ObiTwowayStackedClosedRightElement,
   events: {
     
   }
  });
 
 